import React from 'react'
import { Grid as BaseGrid, styled } from '@mui/material'
import { Card as BaseCard, Table as BaseTable, TableCell as BaseTableCell } from '@chilecompra/react-kit/components'

export const Card = styled(({ children, textAlign, ...props }) => <BaseCard {...props}>{children}</BaseCard>)`
  align-items: ${props => props.alignItems};
  display: flex;
  height: ${props => props.height};
  margin: ${props => props.margin};
  width: ${props => props.width};
`

export const CardItem = styled(({ ...props }) => <div {...props} />)`
  align-items: center;
  display: flex;
  flex-direction: ${props => props.direction || 'flex'};
  justify-content: center;
  padding: ${props => props.padding};
`

export const Column = styled(({ flexBasis, flexGrow, width, ...props }) => <BaseGrid item {...props} />)`
  &.MuiGrid-root {
    flex-basis: ${props => props.flexBasis};
    flex-grow: ${props => props.flexGrow};
    margin: ${props => props.margin || 0};
    width: ${props => props.width};
  }
  &.MuiGrid-root:first-child {
    padding: 10px 10px 0 0;
  }
`

export const Root = styled('div')`
  width: 100%;
`

export const Row = styled(({ ...props }) => <BaseGrid container {...props} />)`
  margin-bottom: 10px;
`

export const Separator = styled('hr')`
  border: 0;
  border-top: 1px solid ${props => props.theme.palette.custom.gray[75.5]};
  box-sizing: content-box;
  height: 0;
  margin: 12px 0 12px;
  overflow: visible;
`

export const Strong = styled('span')`
  font-weight: bold;
`

export const Table = styled(BaseTable)(({ theme }) => ({
  '&.MuiTable-root:last-of-type': {
    padding: '0 0 15px 0',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '50%'
    }
  }
}))

export const TableCell = styled(BaseTableCell)`
  &&& {
    &.MuiTableCell-root:first-of-type {
      padding: ${props => props.padding || '12px 9px 10px'};
    }
  }
`

export const WarningImg = styled('img')`
  color: ${props => props.theme.palette.brand.black3};
  height: 48px;
  margin: ${props => props.margin};
  width: 48px;
`
